import React, { Component } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { getConfirmVM } from 'state/viewModels'
import Price from 'components/Price'
import PaintFillSummary from 'components/PaintFillSummary'
import InitialsSummary from 'components/InitialsSummary'
import StampSummary from 'components/StampSummary'
import AccessorySelection from 'components/AccessorySelection'
import StampSwatch from 'components/StampSwatch'
import "./ConfirmView.css"

function getPrice(...args){
  return args.reduce((t, obj) => t + ((obj && obj.price) || 0), 0);
}

export class ConfirmView extends Component {

  render = () => (
    <div className="confirm-view">
      <div className="confirm-view-putter-label">
        {this.props.putterLabel}
        {this.props.accessories.buyAPutter.selected &&
          <div className="buy-a-putter-price-section">
            <span className="buy-a-putter-label">NEW PUTTER: </span>
            <span className="buy-a-putter-price">${this.props.accessories.buyAPutter.selected.price}</span>
          </div>
        }
      </div>
      <div className="confirm-view-images">
        {
          this.props.views.map((v) => {
            return (v.src !== '')
              ? <img key={v.name} alt={v.name} src={v.src} 
                />
              : ''
          })
        }
      </div>
      <div className="putter-summary">
        <div className="finish-face-summary">
          <div className="customize-form-header">Finish & Paintfill</div>
          {this.props.finish.selected &&
            <div className="customize-form-section">
              <div className="customize-form-section-header">
                {this.props.finish.selected.label}
                {!!this.props.finish.finish.selected &&
                  <div className="customize-form-section-content">
                    {this.props.finish.finish.selected.label} Finish
                  </div>
                }
                <Price value={getPrice(this.props.finish.selected)} />
              </div>
            </div>
          }
          <div className="customize-form-header">Face</div>
          {this.props.face.paintFillLocations.length > 0 && 
            <PaintFillSummary paints={this.props.face.paintFillLocations} header="PAINTFILL"/>
          }
          {this.props.face.initials.length > 0 && 
            <InitialsSummary initials={this.props.face.initials} />
          }
          {this.props.face.stampsLocations.length > 0 &&
            <StampSummary stamps={this.props.face.stampsLocations} />
          }
        </div>
        <div className="back-summary">
          <div className="customize-form-header">Back</div>
          {this.props.back.paintFillLocations.length > 0 && 
            <PaintFillSummary paints={this.props.back.paintFillLocations} header="PAINTFILL"/>
          }
          {this.props.back.initials.length > 0 && 
            <InitialsSummary initials={this.props.back.initials} />
          }
          {this.props.back.stampsLocations.length > 0 && 
            <StampSummary stamps={this.props.back.stampsLocations} />
          }
        </div>
        <div className="top-specs-summary">
          <div className="customize-form-header">Top</div>
          {this.props.top.paintFillLocations.length > 0 && 
            <PaintFillSummary paints={this.props.top.paintFillLocations} header="PAINTFILL"/>
          }
          {this.props.top.sightDots.selected && 
            <div className="customize-form-section">
              <div className="customize-form-section-header">
                Top Lines
                <Price value={getPrice(this.props.top.sightDots.selected)} />
              </div>
              <div className="customize-form-section-content">
                {this.props.top.sightDots.selected.label}
                {this.props.top.sightDots.paints.length > 0 && 
                <PaintFillSummary paints={this.props.top.sightDots.paints} labelOverride={'Dot'}/>
                }
              </div>
            </div>    
          }
          {this.props.top.topLines.selected && 
            <div className="customize-form-section">
                <div className="customize-form-section-header">
                  Top Lines 
                  <Price value={getPrice(this.props.top.topLines.selected)} />
                </div>
                <div className="customize-form-section-content">
                  {this.props.top.topLines.selected.label}
                  {this.props.top.topLines.paints.length > 0 && 
                    <PaintFillSummary paints={this.props.top.topLines.paints} />
                  }
                </div>
            </div>
          }
          {this.props.top.flangeLines.selected && 
            <div className="customize-form-section">
              <div className="customize-form-section-header">
                Flange Lines
                <Price value={ ((this.props.top.topLines.selected && this.props.top.topLines.selected.price > 0) ||
                  ((this.props.top.sightDots.selected && this.props.top.sightDots.selected.price > 0) )) ? 
                  this.props.top.flangeLines.selected.discountPrice : 
                  this.props.top.flangeLines.selected.price } />
              </div>
              <div className="customize-form-section-content">
                {this.props.top.flangeLines.selected.label}
                {this.props.top.flangeLines.paints.length > 0 && 
                <PaintFillSummary paints={this.props.top.flangeLines.paints} />
                }
              </div>
            </div>
          }
          <div className="customize-form-header">Specs</div>
          {this.props.specs.hasWeights && 
            <div className="customize-form-section">
              <div className="customize-form-section-header">
                Weight
                <Price value={getPrice(this.props.specs.weight.selected, this.props.specs.weight.selectedEngraving)} />
              </div>
              {this.props.specs.weight.selected && 
                <div className="customize-form-section">
                  <div className="customize-form-section-content weight-summary">
                    {this.props.specs.weight.selected.label}
                    <Price value={getPrice(this.props.specs.weight.selected)} />
                  </div>
                </div>
              }
              {!this.props.specs.weight.selected && 
                <div className="customize-form-section">
                  <div className="customize-form-section-content">
                    Keep As Is
                  </div>
                </div>
              }
              {this.props.specs.weight.selectedEngraving &&
                <div className="customize-form-section-content weight-engraving-summary">
                  Weight Engraving
                  <Price value={getPrice(this.props.specs.weight.selectedEngraving)} />
                    <div className="customize-form-section">
                        <div className="customize-form-section-content weight-summary">
                            Style: {this.props.specs.weight.selectedEngraving.label}
                        </div>
                    </div>
                  {this.props.specs.weight.frontEngraving.selected &&
                    <div className="paintfill-chooser">
                      <div className="paintfill-selection">
                        {this.props.specs.weight.frontEngraving.loc.label}
                        <StampSwatch stamp={this.props.specs.weight.frontEngraving.selected} selected={false} />
                        {this.props.specs.weight.frontPaint && this.props.specs.weight.frontPaint.selected &&
                          <div className="weight-engraving-paint-summary">
                            <PaintFillSummary paints={[this.props.specs.weight.frontPaint]} />
                          </div>
                        }
                      </div>
                    </div>
                  }
                  {this.props.specs.weight.rearEngraving.selected &&
                    <div className="paintfill-chooser">
                      <div className="paintfill-selection">
                        {this.props.specs.weight.rearEngraving.loc.label}
                        <StampSwatch stamp={this.props.specs.weight.rearEngraving.selected} selected={false} />
                        {this.props.specs.weight.rearPaint && this.props.specs.weight.rearPaint.selected &&
                          <div className="weight-engraving-paint-summary">
                            <PaintFillSummary paints={[this.props.specs.weight.rearPaint]} />
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          {this.props.specs.hasTopWeights && 
            <div className="customize-form-section">
              <div className="customize-form-section-header">
                <span className="sub-header">Top Weight</span>
                <Price value={getPrice(this.props.specs.topWeight.selected, this.props.specs.topWeight.selectedEngraving)} />
              </div>
              {this.props.specs.topWeight.selected && 
                <div className="customize-form-section">
                  <div className="customize-form-section-content weight-summary">
                    {this.props.specs.topWeight.selected.label}
                    <Price value={getPrice(this.props.specs.topWeight.selected)} />
                  </div>
                </div>
              }
              {!this.props.specs.topWeight.selected && 
                <div className="customize-form-section">
                  <div className="customize-form-section-content">
                    Keep As Is
                  </div>
                </div>
              }
              {this.props.specs.topWeight.selectedEngraving &&
                <div className="customize-form-section-content weight-engraving-summary">
                  Weight Engraving
                    <Price value={getPrice(this.props.specs.topWeight.selectedEngraving)} />
                    <div className="customize-form-section">
                        <div className="customize-form-section-content weight-summary">
                            Style: {this.props.specs.topWeight.selectedEngraving.label}
                        </div>
                    </div>
                  {this.props.specs.topWeight.frontEngraving.selected &&
                    <div className="paintfill-chooser">
                      <div className="paintfill-selection">
                        {this.props.specs.topWeight.frontEngraving.loc.label}
                        <StampSwatch stamp={this.props.specs.topWeight.frontEngraving.selected} selected={false} />
                        {this.props.specs.topWeight.frontPaint.selected &&
                          <div className="weight-engraving-paint-summary">
                            <PaintFillSummary paints={[this.props.specs.topWeight.frontPaint]} />
                          </div>
                        }
                      </div>
                    </div>
                  }
                  {this.props.specs.topWeight.rearEngraving.selected &&
                    <div className="paintfill-chooser">
                      <div className="paintfill-selection">
                        {this.props.specs.topWeight.rearEngraving.loc.label}
                        <StampSwatch stamp={this.props.specs.topWeight.rearEngraving.selected} selected={false} />
                        {this.props.specs.topWeight.rearPaint.selected &&
                          <div className="weight-engraving-paint-summary">
                            <PaintFillSummary paints={[this.props.specs.topWeight.rearPaint]} />
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div className="customize-form-section">
              {this.props.specs.loft.selected && 
                <div className="customize-form-section-header">Loft</div>
              }
              {this.props.specs.loft.selected && 
                <div className="customize-form-section-content">
                  {this.props.specs.loft.selected.label}
                </div>
              }
          </div>
          <div className="customize-form-section">
            {this.props.specs.lie.selected && 
              <div className="customize-form-section-header">Lie</div>
            }
            {this.props.specs.lie.selected && 
              <div className="customize-form-section-content">
                {this.props.specs.lie.selected.label}
              </div>
            }
          </div>
          <div className="customize-form-section">
              {this.props.specs.length.selected && 
                <div className="customize-form-section-header">Length</div>
              }
              {this.props.specs.length.selected && 
                <div className="customize-form-section-content">
                  {this.props.specs.length.selected.label}
                  {this.props.specs.length.selected.userSelection && this.props.specs.desiredLength.selected &&
                    <span className="selected-option">
                      {this.props.specs.desiredLength.selected.label}
                    </span>
                  }
                </div>
              }
          </div>
          <div className={classNames("customize-form-section", {"hidden":this.props.specs.buyAPutter && this.props.specs.buyAPutter.selected})}>
              {this.props.specs.reshaft.selected && 
                <div className="customize-form-section-header">
                  Shaft
                  <Price value={getPrice(this.props.specs.reshaft.selected)} />
                </div>
              }
              {this.props.specs.reshaft.selected && 
                <div className="customize-form-section-content">
                  {this.props.specs.reshaft.selected.label}
                </div>
              }
          </div>
        </div>
      </div>
      {(this.props.accessories.grip.selected || this.props.accessories.shaftBand.selected || this.props.accessories.headCover.selected) &&
        <div className="accessories-summary">
          <div className="customize-form-header">Accessories</div>
          {this.props.accessories.grip.selected && 
            <div className="customize-form-section">
              <AccessorySelection 
                selected={this.props.accessories.grip.selected} 
                accessoryType="grip" 
                reshaft={this.props.accessories.reshaft}
                restoration={this.props.accessories.restoration} 
              />
              {this.props.accessories.gripWrap.selected &&
                <div className="grip-wraps">
                  ({this.props.accessories.gripWrap.selected.label})
                </div>
              }
            </div>
          }
          {this.props.accessories.shaftBand.selected && 
            <div className="customize-form-section">
              <AccessorySelection 
                selected={this.props.accessories.shaftBand.selected} 
                accessoryType="shaftBand" 
                reshaft={this.props.accessories.reshaft}
                restoration={this.props.accessories.restoration} 
              />
            </div>
          }
          {this.props.accessories.headCover.selected && 
            <div className="customize-form-section">
              <AccessorySelection 
                  selected={this.props.accessories.headCover.selected} 
                  accessoryType="headCover" 
                  reshaft={this.props.accessories.reshaft}
                  restoration={this.props.accessories.restoration} 
                />
            </div>
          }
        </div>
      }
      {this.props.auth.selected &&
        <div className="authentication-summary">
          <div className="customize-form-header">Authentication</div>
          <div className="customize-form-section">
            {this.props.auth.selected.label} 
            <Price value={getPrice(this.props.auth.selected)} />
          </div>
        </div>
      }
      <div className="pricing-summary">
        <div className="customize-form-header pricing-total">Pricing Total: ${this.props.price.total}</div>
      </div>
    </div>
  )
}

ConfirmView.defaultProps = {
};

const mapStateToProps = (state, ownProps) => {
  return { ...getConfirmVM(state.customize),
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmView);